import { reclaimActivationEntrySources } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

export const enableDisputes = {
  name: "enableDisputes" as const,
  input: z.object({
    entrySource: z.enum(reclaimActivationEntrySources).optional(),
    /** Campaign link code (`?c=`), resolved server-side in the same call. */
    campaignCode: z.string().min(1).max(200).optional(),
  }),
  output: z.object({
    status: z.enum([
      "trial_started",
      "trial_already_active",
      "billing_already_enabled",
      "free_access_enabled",
      "billing_required",
    ]),
  }),
};
